import { LegacyProductCode } from '@up2stay/up2promo-api-client';

/** Setup-frontend + app scan product kinds — api-client enum only. */
export const SETUP_PRODUCT_TYPES: readonly LegacyProductCode[] = [
  LegacyProductCode.GO,
  LegacyProductCode.IG,
  LegacyProductCode.TT,
  LegacyProductCode.FB,
  LegacyProductCode.ME,
  LegacyProductCode.CU,
  LegacyProductCode.BC,
] as const;

const PRODUCT_TYPE_BY_CODE = new Map<string, LegacyProductCode>(
  SETUP_PRODUCT_TYPES.map((value) => [value, value]),
);

export function isSetupProductType(
  value: string | null | undefined,
): value is LegacyProductCode {
  if (!value?.trim()) return false;
  return PRODUCT_TYPE_BY_CODE.has(value.trim().toUpperCase());
}

/** Parse setup-frontend `t` and/or app `type` into LegacyProductCode. */
export function parseSetupTypeParam(
  ...candidates: Array<string | null | undefined>
): LegacyProductCode | undefined {
  for (const raw of candidates) {
    const code = raw?.trim().toUpperCase();
    if (!code) continue;
    const matched = PRODUCT_TYPE_BY_CODE.get(code);
    if (matched) return matched;
  }
  return undefined;
}
